export default "__VITE_ASSET__Bfit$310__"